<template>
  <SplashScreen/>
  <router-view />
</template>

<script>
import SplashScreen from './components/SplashScreen.vue';
import { computed, reactive } from 'vue'
import {useHead } from '@vueuse/head'

export default {
    name: 'App',
    components: { SplashScreen },
    setup() {
    const siteData = reactive({
      title: `Darts | coeo Group`,
      description: `We balance Customer Relationships – mit verbraucherzentriertem, technologiebasiertem Inkasso.`,
      keywords: `keywords`
    })
    useHead({
      title: computed(() => siteData.title),
      meta: [
        {
          meta:`description`,
          content: computed(() => siteData.description),
        },
        {
          meta:`keywords`,
          content: computed(() => siteData.keywords),
        }
      ],
      htmlAttrs: {
        lang: "de-DE",
      },
    })
  }
}
</script>